import React from "react";
import {
  AppBar,
  IconButton,
  SwipeableDrawer,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FIXED_SIZES = {
  small: 450,
  medium: 700,
  large: 900,
  full: "100%",
};

const Drawer = ({
  open,
  onClose,
  title,
  children,
  size = "small",
  position = "right",
}) => {
  return (
    <>
      <SwipeableDrawer
        anchor={position}
        open={open}
        onClose={onClose}
        onOpen={() => {}}
        PaperProps={{
          sx: {
            width: FIXED_SIZES[size],
            height: "100%",
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {title}
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={handleClose}>
              save
            </Button> */}
            <IconButton
              edge="start"
              onClick={onClose}
              aria-label="close"
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="container py-2">{children}</div>
      </SwipeableDrawer>
    </>
  );
};

export default Drawer;
